import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import Plan from "./Plan";
import settings from "./swipeSettings";
import planType from "./types/planType";
import { Wrapper, TermsInfo, TermsLink } from "./styles/annually-styles";
import { NoPlansAvailableText } from "./styles/shared-styles";

const AnnualPlansList = ({ annually, termsAnnually }) => (
  <Wrapper>
    {annually.length > 0 ? (
      <>
        <Slider {...settings(annually.length)}>
          {annually.map((plan, index) => (
            <Plan
              key={plan.id}
              {...plan}
              plansCount={annually.length}
              index={index}
              paymentFrequency="annually"
            />
          ))}
        </Slider>
        <TermsInfo className="animated fadeIn delay">
          {termsAnnually} Read the{" "}
          <TermsLink
            href="https://www.hiring-hub.com/termsofbusiness/"
            rel="noopener noreferrer"
            target="_blank"
            data-test-id="terms-link"
          >
            Terms of business
          </TermsLink>
          .
        </TermsInfo>
      </>
    ) : (
      <NoPlansAvailableText>
        Please contact your account manager to discuss our annual plan options.
      </NoPlansAvailableText>
    )}
  </Wrapper>
);

AnnualPlansList.propTypes = {
  annually: PropTypes.arrayOf(planType).isRequired,
  termsAnnually: PropTypes.string,
  toggleTermsModal: PropTypes.func.isRequired,
};

AnnualPlansList.defaultProps = {
  termsAnnually: PropTypes.isNull,
};

export default AnnualPlansList;
